<template>
    <span></span>
</template>

<script>
    export default {
        /*
        data() {
            return gdpr_notice
        :
            'Durch Abschicken dieses Formulars stimmen Sie der Speicherung und Verarbeitung Ihrer Daten gemäß unserer <a href="https://www.animod.de/c/datenschutz" target="_blank">Datenschutzerklärung</a> zu.'
        },
        */
        name: 'GdprNotice'
    }
</script>
